export default "__VITE_ASSET__EQkWjIMg__"